module.exports = new __parcel__URL__("gasa_embassy_level_3.830a4cee.png").toString();